"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcAddressList = class UcAddressList extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    parent;
    onParent(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("parent");
    }
    container;
    async $$load_container() {
        return this.parent.addresses;
    }
    items;
    async $$load_items() {
        return this.container.data;
    }
    ux;
    dataMembers = ['container', 'items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                container: null,
                items: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_emit_8476_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8320016629450276_close_8475_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_8320016629450276_showModal_8474_getActionArgs($event) {
        return {
            name: "Address",
            props: {
                parent: this.parent,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_294572930540096_emit_8480_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_294572930540096_close_8479_getWhen($event) {
        return $event.data.modalResult && $event.data.modalResult.ok;
    }
    async act_294572930540096_showModal_8478_getActionArgs($event) {
        return {
            name: "Address",
            props: {
                parent: this.parent,
                item: $event.scope.item,
            },
        };
    }
    async evh_294572930540096_clickPreventStop(event, scope) {
        return await this.actions.evh_294572930540096_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3365375699802249_rest_8482_getActionArgs($event) {
        return {
            method: "delete",
            container: this.container,
            resource: $event.scope.item,
        };
    }
    async act_3365375699802249_rest_8482_getConfirm($event) {
        return {
            message: this.$fn.gettext("Please confirm delete."),
            btnOk: this.$fn.gettext("Delete"),
        };
    }
    async evh_3365375699802249_clickPreventStop(event, scope) {
        return await this.actions.evh_3365375699802249_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_8472 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_8471 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_8472,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_8471],
        });
        const act_8320016629450276_emit_8476 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_8476_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_close_8475 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_8476,
            event: "close",
            when: this.evh_8320016629450276_close_8475_getWhen,
            displayName: "emit",
        });
        const act_8320016629450276_showModal_8474 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_8474_getActionArgs,
            displayName: "create",
            events: [evh_8320016629450276_close_8475],
        });
        const evh_8320016629450276_clickPreventStop_8473 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_8474,
            event: "click.prevent.stop",
            displayName: "create",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_8473],
        });
        const act_294572930540096_emit_8480 = new core_1.actions.EmitAction({
            actionArgs: this.act_294572930540096_emit_8480_getActionArgs,
            events: [],
        });
        const evh_294572930540096_close_8479 = new core_1.actions.EventHandlerImpl({
            action: act_294572930540096_emit_8480,
            event: "close",
            when: this.evh_294572930540096_close_8479_getWhen,
            displayName: "emit",
        });
        const act_294572930540096_showModal_8478 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_294572930540096_showModal_8478_getActionArgs,
            events: [evh_294572930540096_close_8479],
        });
        const evh_294572930540096_clickPreventStop_8477 = new core_1.actions.EventHandlerImpl({
            action: act_294572930540096_showModal_8478,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_294572930540096_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_294572930540096_clickPreventStop_8477],
        });
        const act_3365375699802249_rest_8482 = new core_1.actions.RestAction({
            actionArgs: this.act_3365375699802249_rest_8482_getActionArgs,
            confirm: this.act_3365375699802249_rest_8482_getConfirm,
            events: [],
        });
        const evh_3365375699802249_clickPreventStop_8481 = new core_1.actions.EventHandlerImpl({
            action: act_3365375699802249_rest_8482,
            event: "click.prevent.stop",
            displayName: "rest",
        });
        const evh_3365375699802249_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3365375699802249_clickPreventStop_8481],
        });
        return {
            act_7315092382398562_reloadComponentData_8472,
            evh_7315092382398562_reload_8471,
            evh_7315092382398562_reload,
            act_8320016629450276_emit_8476,
            evh_8320016629450276_close_8475,
            act_8320016629450276_showModal_8474,
            evh_8320016629450276_clickPreventStop_8473,
            evh_8320016629450276_clickPreventStop,
            act_294572930540096_emit_8480,
            evh_294572930540096_close_8479,
            act_294572930540096_showModal_8478,
            evh_294572930540096_clickPreventStop_8477,
            evh_294572930540096_clickPreventStop,
            act_3365375699802249_rest_8482,
            evh_3365375699802249_clickPreventStop_8481,
            evh_3365375699802249_clickPreventStop,
            create: act_8320016629450276_showModal_8474,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcAddressList.prototype, "parent", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('parent'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAddressList.prototype, "onParent", null);
UcAddressList = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcAddressList);
exports.default = UcAddressList;
vue_property_decorator_1.Vue.component("UcAddressList", UcAddressList);
